import { call, put, all, takeEvery, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ApiResponse } from 'types/ApiResponse';
import {
  getClaimsByFilter,
  getClaimsByBrokerFilter,
} from 'services/claimsService';
import { SagasAction } from 'types/SagasAction';
import { ApplicationState } from 'store/store.inteface';
import { setDataTable, clearDataTable } from './actions';
import { MANAGEMENT_TYPES, SagaTable } from './types';

export function* setDataTableSaga({ payload }: SagasAction<SagaTable>) {
  clearDataTable(payload.table);
  const { stores, cpId } = yield select(
    (state: ApplicationState) => state.storesContext,
  );
  try {
    if (payload.type === 'movement') {
      const { data }: AxiosResponse<ApiResponse<any>> = yield call(
        getClaimsByFilter,
        cpId,
        stores[0]?.code,
        payload.filter,
      );
      yield put(setDataTable(payload.table, payload.type, data.response));
    }
    if (payload.type === 'status') {
      const { data }: AxiosResponse<ApiResponse<any>> = yield call(
        getClaimsByBrokerFilter,
        cpId,
        stores[0]?.code,
        payload.filter,
      );
      yield put(setDataTable(payload.table, payload.type, data.response));
    }
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeEvery(MANAGEMENT_TYPES.GET_DATA_TABLE, setDataTableSaga),
]);
